import {http} from './config/config-receituario'

export default{
    listar:(token)=>{
        return  http.get('produtores',{
            headers:{
                'Authorization':token
            }
        })
    },
    listarByFilter:(token, nome)=>{
        return  http.get(`produtores/filter?nome=${encodeURIComponent(nome)}`,{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, produtor)=>{
        return http.post('produtores',produtor,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idProdutor)=>{
        return http.delete('produtores/'+idProdutor,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, produtor)=>{
        return http.put('produtores/'+produtor.id_produtor_rural,produtor,{
            headers:{
                'Authorization':token
            }
        })
    }

}
